module.exports = __webpack_public_path__ + "static/img/zp.07cff96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/classmates/zp.png
// module id = qKkc
// module chunks = 43